import { render } from "./Feature2.vue?vue&type=template&id=2de82982"
import script from "./Feature2.vue?vue&type=script&lang=js"
export * from "./Feature2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__